import { Decimal, Format, PercentageFormatter } from '@zervant/reactcomponents'

export const convertPercentageFromLocale = (value: number, locale: string): string => {
  const pctFormat = Format.fromLocale(locale)
  const percent = new Decimal(value).toNumber()
  const isDecimal = !Number.isInteger(percent)
  pctFormat.numbers.decimalAccuracy = 1
  const percentageF = new PercentageFormatter(pctFormat, isDecimal)
  return percentageF.render(percent)
}
